import React from 'react';
import NormalConComponent from '@/page/conversation/NormalConComponent';

export default function CustomerPage() {
    return (
        <NormalConComponent
            receiveTabs={[
                {name: '员工', key: 2},
                {name: '群聊', key: 3},
            ]}
            sendType={1}
            title={'客户会话查询'}
        />
    );
}
